import script from "./website.vue?vue&type=script&lang=js"
export * from "./website.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/horizontal/website.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e008b0b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e008b0b', __exports__)) {
    console.log('reload')
    api.reload('2e008b0b', __exports__)
  }
  
}


export default __exports__